module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "series",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "100",
      "src": "images/logo-chicago-guides.jpg",
      "width": "147"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing for Social Scientists")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Howard S. Becker")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing Your Journal Article in Twelve Weeks")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Wendy Laura Belcher")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Janet Burroway, with Elizabeth Stuckey-French and Ned Stuckey-French")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Writing Abroad")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Peter Chilson and Joanne B. Mulcahy")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Architecture of Story")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Will Dunne")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Business of Being a Writer")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Jane Friedman")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("From Dissertation to Book")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("William Germano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Getting It Published")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("William Germano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("From Notes to Narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Kristen Ghodsee")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Storycraft")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Jack Hart")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Thinking Like a Political Scientist")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Christopher Howard")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Write No Matter What")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Joli Jensen")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Economical Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Deirdre Nansen McCloskey")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Developmental Editing")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Scott Norton")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Writer’s Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Helen Sword")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Write Your Way In")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Rachel Toor")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ef76b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-germano-0003.vue
// module id = 60
// module chunks = 0